<div *ngFor="let Source of Sources">
    <div class="card">
        <h5 class="card-title">{{Source.nome | translate}}</h5>
        <div class="card-body">
            <ul class="list-group custom-group message-center" style="max-width: 400px; overflow-x: visible" id="sidebar">
              <app-categorie-nav
                [(Categorie)]="Source.categorie"
                [HasAdd]="true"
                [Sublist]="false"
                (Refresh)="RefreshList()"
                [Source]="Source"
                (Save)="Salva($event)"
                (Navigate)="Navigate.emit($event)"
                [(modificheAbilitate)]="modificheAbilitate"
                [(sel_cat_id)]="sel_cat_id"
                [Capacita]="Capacita"
                (DeleteClick)="Delete($event)"
                [(CatFull)]="CatFull"
              ></app-categorie-nav>
            </ul>
        </div>
    </div>
</div>
